module.exports = "/_next/static/images/PersonalizationStrategies@2x-55792db8f5fc08770a2743c11448b349.webp";